import request from '@/utils/request'

export default {
  async addUserAction (params) {
    let res = await request.post('/userActions/add', params)
    return res.data
  },
  // 个人相关推荐
  async selectPersonalKeywords (params) {
    let res = await request.get('/userActions/selectPersonalKeywords', { params })
    return res.data
  }
}
